import './page.css';
export default {
  "button": "pf-v6-c-button",
  "dirRtl": "pf-v6-m-dir-rtl",
  "drawer": "pf-v6-c-drawer",
  "drawerMain": "pf-v6-c-drawer__main",
  "drawerPanel": "pf-v6-c-drawer__panel",
  "masthead": "pf-v6-c-masthead",
  "mastheadToggle": "pf-v6-c-masthead__toggle",
  "modifiers": {
    "hamburger": "pf-m-hamburger",
    "expanded": "pf-m-expanded",
    "collapsed": "pf-m-collapsed",
    "pageInsets": "pf-m-page-insets",
    "contextSelector": "pf-m-context-selector",
    "insetNone": "pf-m-inset-none",
    "fill": "pf-m-fill",
    "noFill": "pf-m-no-fill",
    "limitWidth": "pf-m-limit-width",
    "alignCenter": "pf-m-align-center",
    "overflowScroll": "pf-m-overflow-scroll",
    "shadowBottom": "pf-m-shadow-bottom",
    "shadowTop": "pf-m-shadow-top",
    "stickyTop": "pf-m-sticky-top",
    "stickyBottom": "pf-m-sticky-bottom",
    "stickyTopOnSmHeight": "pf-m-sticky-top-on-sm-height",
    "stickyBottomOnSmHeight": "pf-m-sticky-bottom-on-sm-height",
    "stickyTopOnMdHeight": "pf-m-sticky-top-on-md-height",
    "stickyBottomOnMdHeight": "pf-m-sticky-bottom-on-md-height",
    "stickyTopOnLgHeight": "pf-m-sticky-top-on-lg-height",
    "stickyBottomOnLgHeight": "pf-m-sticky-bottom-on-lg-height",
    "stickyTopOnXlHeight": "pf-m-sticky-top-on-xl-height",
    "stickyBottomOnXlHeight": "pf-m-sticky-bottom-on-xl-height",
    "stickyTopOn_2xlHeight": "pf-m-sticky-top-on-2xl-height",
    "stickyBottomOn_2xlHeight": "pf-m-sticky-bottom-on-2xl-height",
    "noSidebar": "pf-m-no-sidebar",
    "secondary": "pf-m-secondary",
    "padding": "pf-m-padding",
    "noPadding": "pf-m-no-padding",
    "paddingOnSm": "pf-m-padding-on-sm",
    "noPaddingOnSm": "pf-m-no-padding-on-sm",
    "paddingOnMd": "pf-m-padding-on-md",
    "noPaddingOnMd": "pf-m-no-padding-on-md",
    "paddingOnLg": "pf-m-padding-on-lg",
    "noPaddingOnLg": "pf-m-no-padding-on-lg",
    "paddingOnXl": "pf-m-padding-on-xl",
    "noPaddingOnXl": "pf-m-no-padding-on-xl",
    "paddingOn_2xl": "pf-m-padding-on-2xl",
    "noPaddingOn_2xl": "pf-m-no-padding-on-2xl"
  },
  "page": "pf-v6-c-page",
  "pageDrawer": "pf-v6-c-page__drawer",
  "pageMain": "pf-v6-c-page__main",
  "pageMainBody": "pf-v6-c-page__main-body",
  "pageMainBreadcrumb": "pf-v6-c-page__main-breadcrumb",
  "pageMainContainer": "pf-v6-c-page__main-container",
  "pageMainDrawer": "pf-v6-c-page__main-drawer",
  "pageMainGroup": "pf-v6-c-page__main-group",
  "pageMainSection": "pf-v6-c-page__main-section",
  "pageMainSubnav": "pf-v6-c-page__main-subnav",
  "pageMainTabs": "pf-v6-c-page__main-tabs",
  "pageMainWizard": "pf-v6-c-page__main-wizard",
  "pageSidebar": "pf-v6-c-page__sidebar",
  "pageSidebarBody": "pf-v6-c-page__sidebar-body",
  "pageSidebarHeader": "pf-v6-c-page__sidebar-header",
  "pageSidebarTitle": "pf-v6-c-page__sidebar-title"
};